const PROJECT_USERS_OPTIONS = {
    fetchType: 'projectUsers',
    multiSelect: true
};

const PROJECT_USERS_WITH_ANY_OPTIONS = {
    fetchType: 'projectUsers',
    multiSelect: true,
    list: [
        {
            id: 'any',
            text: 'anyone',
            single: true
        }
    ]
};

const TEAM_USERS_OPTIONS = {
    fetchType: 'teamUsers',
    multiSelect: true
};

const TASK_GROUPS_OPTIONS = {
    fetchType: 'projectTaskGroups',
    multiSelect: true,
    list: [
        {
            id: 'any',
            text: 'any status',
            single: true
        }
    ]
};

const LABEL_OPTIONS = {
    fetchType: 'labels',
    multiSelect: true
};

const SEND_MESSAGE_OPTIONS = {
    list: [
        {
            id: 'project',
            text: 'in the project'
        },
        {
            id: 'direct',
            text: 'in direct chat',
            after: {
                id: 'user',
                preposition: 'to',
                options: TEAM_USERS_OPTIONS
            }
        }
    ]
};

const TASK_TRIGGER_OPTIONS = {
    type: 'static',
    list: [
        {
            id: 'created',
            text: 'created',
            after: {
                id: 'taskGroup',
                preposition: 'in',
                options: TASK_GROUPS_OPTIONS,
                after: {
                    id: 'by',
                    preposition: 'by',
                    options: PROJECT_USERS_WITH_ANY_OPTIONS
                }
            }
        },
        {
            id: 'moved',
            text: 'moved',
            after: {
                id: 'taskGroup',
                preposition: 'to',
                options: TASK_GROUPS_OPTIONS,
                after: {
                    id: 'by',
                    preposition: 'by',
                    options: PROJECT_USERS_WITH_ANY_OPTIONS
                }
            }
        },
        {
            id: 'completed',
            text: 'completed',
            after: {
                id: 'by',
                preposition: 'by',
                options: PROJECT_USERS_WITH_ANY_OPTIONS
            }
        },
        {
            id: 'overdue',
            text: 'overdue',
            after: {
                id: 'taskGroup',
                preposition: 'in',
                options: TASK_GROUPS_OPTIONS
            }
        },
        {
            id: 'reminding',
            text: 'reminding',
            after: {
                id: 'taskGroup',
                preposition: 'in',
                options: TASK_GROUPS_OPTIONS
            }
        },
        // {
        //     id: 'timeTracked',
        //     text: 'time tracked',
        //     after: {
        //         id: 'by',
        //         preposition: 'by',
        //         options: PROJECT_USERS_WITH_ANY_OPTIONS
        //     }
        // }
    ]
};

const MILESTONE_TRIGGER_OPTIONS = {
    type: 'static',
    list: [
        {
            id: 'unlocked',
            text: 'unlocked'
        },
        {
            id: 'completed',
            text: 'completed'
        },
        {
            id: 'overdue',
            text: 'overdue'
        }
    ]
};

const TEAM_CHAT_TRIGGER_OPTIONS = {
    type: 'static',
    list: [
        {
            id: 'messageReceived',
            text: 'message is received'
        }
    ]
};

export const TRIGGERS = {
    id: 'resource',
    type: 'static',
    list: [
        {
            id: 'task',
            text: 'task',
            after: {
                id: 'id',
                preposition: 'is',
                options: TASK_TRIGGER_OPTIONS

            }
        },
        // {
        //     id: 'milestone',
        //     text: 'milestone',
        //     after: {
        //         id: 'id',
        //         preposition: 'is',
        //         options: MILESTONE_TRIGGER_OPTIONS

        //     }
        // },
        // {
        //     id: 'teamChat',
        //     text: 'team chat',
        //     after: {
        //         id: 'id',
        //         // preposition: 'is',
        //         options: TEAM_CHAT_TRIGGER_OPTIONS

        //     }
        // }
    ]
};

export const ACTIONS = {
    id: 'id',
    type: 'static',
    list: [
        {
            id: 'assignUser',
            text: 'Assign',
            after: {
                id: 'user',
                options: PROJECT_USERS_OPTIONS
            }
        },
        {
            id: 'unassignUser',
            text: 'Unassign',
            after: {
                id: 'user',
                options: PROJECT_USERS_OPTIONS
            }
        },
        {
            id: 'setStartDate',
            text: 'Set start date',
            after: {
                id: 'inDays',
                preposition: 'in',
                inputType: 'number',
                textAfter: 'days'
            }
        },
        {
            id: 'setDueDate',
            text: 'Set due date',
            after: {
                id: 'inDays',
                preposition: 'in',
                inputType: 'number',
                textAfter: 'days'
            }
        },
        {
            id: 'addLabel',
            text: 'Add tag',
            after: {
                id: 'label',
                options: LABEL_OPTIONS
            }
        },
        {
            id: 'removeLabel',
            text: 'Remove tag',
            after: {
                id: 'label',
                options: LABEL_OPTIONS
            }
        },
        {
            id: 'createSubtask',
            text: 'Create subtask',
            after: {
                id: 'name',
                preposition: 'named',
                inputType: 'text'
            }
        },
        {
            id: 'subscribe',
            text: 'Subscribe',
            after: {
                id: 'user',
                options: PROJECT_USERS_OPTIONS
            }
        },
        {
            id: 'unsubscribe',
            text: 'Unsubscribe',
            after: {
                id: 'user',
                options: PROJECT_USERS_OPTIONS
            }
        },
        {
            id: 'complete',
            text: 'Complete'
        },
        {
            id: 'archive',
            text: 'Archive'
        },
        {
            id: 'sendMessage',
            text: 'Post a message',
            after: {
                id: 'messageType',
                options: SEND_MESSAGE_OPTIONS
            }
        },
        {
            id: 'sendReply',
            text: 'Send reply',
            after: {
                id: 'message',
                preposition: 'with text',
                inputType: 'text'
            }
        }
    ]
};

export const AVAILABLE_ACTIONS_MAP = {
    'task.created': ['assignUser', 'setStartDate', 'setDueDate', 'addLabel', 'subscribe', 'sendMessage'],
    'task.moved': ['assignUser', 'unassignUser', 'setStartDate', 'setDueDate', 'addLabel', 'removeLabel', 'createSubtask', 'subscribe', 'unsubscribe', 'complete', 'archive', 'sendMessage'],
    'task.completed': ['unassignUser', 'removeLabel', 'unsubscribe', 'archive', 'sendMessage'],
    'task.overdue': ['assignUser', 'unassignUser', 'setStartDate', 'setDueDate', 'addLabel', 'removeLabel', 'createSubtask', 'subscribe', 'unsubscribe', 'complete', 'archive', 'sendMessage'],
    'task.reminding': ['assignUser', 'unassignUser', 'setStartDate', 'setDueDate', 'addLabel', 'removeLabel', 'createSubtask', 'subscribe', 'unsubscribe', 'complete', 'archive', 'sendMessage'],
    'task.timeTracked': ['sendMessage'],
    'milestone.unlocked': ['sendMessage'],
    'milestone.completed': ['archive', 'sendMessage'],
    'milestone.overdue': ['sendMessage'],
    'teamChat.messageReceived': ['sendReply']
};

export const PREDEFINED_AUTOMATIONS = [
    {
        predefined: true,
        id: 'taskCreatedSetStartDate',
        searchTitle: 'task created set start date',
        type: 'task',
        icons: {
            trigger: 'taskCreate',
            action: 'startDate'
        },
        trigger: [
            {
                id: 'resource',
                value: 'task'
            },
            {
                id: 'id',
                value: 'created'
            },
            {
                id: 'taskGroup',
                value: 'any'
            },
            {
                id: 'by',
                value: 'any',
                isLast: true
            }
        ],
        action: [
            [
                {
                    id: 'id',
                    value: 'setStartDate'
                },
                {
                    id: 'inDays',
                    value: 1,
                    isLast: true
                }
            ]
        ]
    },
    {
        id: 'taskCreatedAddLabel',
        predefined: true,
        searchTitle: 'task created add label',
        type: 'task',
        icons: {
            trigger: 'taskCreate',
            action: 'label'
        },
        trigger: [
            {
                id: 'resource',
                value: 'task'
            },
            {
                id: 'id',
                value: 'created'
            },
            {
                id: 'taskGroup',
                value: 'any'
            },
            {
                id: 'by',
                value: 'any',
                isLast: true
            }
        ],
        action: [
            [
                {
                    id: 'id',
                    value: 'addLabel'
                }
            ]
        ]
    },
    {
        id: 'taskMovedSetDueDate',
        predefined: true,
        searchTitle: 'task moved set due date',
        type: 'task',
        icons: {
            trigger: 'taskMove',
            action: 'dueDate'
        },
        trigger: [
            {
                id: 'resource',
                value: 'task'
            },
            {
                id: 'id',
                value: 'moved'
            },
            {
                id: 'taskGroup',
                value: 'any'
            },
            {
                id: 'by',
                value: 'any',
                isLast: true
            }
        ],
        action: [
            [
                {
                    id: 'id',
                    value: 'setDueDate'
                },
                {
                    id: 'inDays',
                    value: 7,
                    isLast: true
                }
            ]
        ]
    },
    {
        id: 'taskCompleteArchive',
        predefined: true,
        searchTitle: 'task complete archive',
        type: 'task',
        icons: {
            trigger: 'taskComplete',
            action: 'archive'
        },
        trigger: [
            {
                id: 'resource',
                value: 'task'
            },
            {
                id: 'id',
                value: 'completed'
            },
            {
                id: 'by',
                value: 'any',
                isLast: true
            }
        ],
        action: [
            [
                {
                    id: 'id',
                    value: 'archive',
                    isLast: true
                }
            ]
        ]
    },
    {
        id: 'taskCompleteSendProjectMessage',
        predefined: true,
        searchTitle: 'task complete send project message',
        type: 'task',
        icons: {
            trigger: 'taskComplete',
            action: 'sendMessage'
        },
        trigger: [
            {
                id: 'resource',
                value: 'task'
            },
            {
                id: 'id',
                value: 'completed'
            },
            {
                id: 'by',
                value: 'any',
                isLast: true
            }
        ],
        action: [
            [
                {
                    id: 'id',
                    value: 'sendMessage'
                },
                {
                    id: 'messageType',
                    value: 'project',
                    isLast: true
                }
            ]
        ]
    },
    {
        id: 'custom',
        predefined: true,
        searchTitle: 'Custom create a new one',
        type: 'custom',
        trigger: [],
        action: []
    }
];

export const TRIGGER_RULES_ORDER = ['resource', 'id', 'taskGroup', 'by'];
export const ACTION_RULES_ORDER = ['id', 'messageType', 'user', 'inDays', 'label', 'name'];
